module.exports = __webpack_public_path__ + "static/media/infinity.1ef4d64f.svg";